import { render, staticRenderFns } from "./TableEmptyState.vue?vue&type=template&id=0e930b20&scoped=true"
import script from "./TableEmptyState.vue?vue&type=script&lang=js"
export * from "./TableEmptyState.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e930b20",
  null
  
)

export default component.exports